import { render } from "./SessionGroupTabs.vue?vue&type=template&id=0a417c9a&scoped=true"
import script from "./SessionGroupTabs.vue?vue&type=script&lang=js"
export * from "./SessionGroupTabs.vue?vue&type=script&lang=js"

import "./SessionGroupTabs.vue?vue&type=style&index=0&id=0a417c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a417c9a"]])

export default __exports__